module.exports = __webpack_public_path__ + "static/media/img-1.9e2395a1.jpg";